import classNames from 'classnames';
import React from 'react';
import UDText from 'ud-ui/components/text';

export interface UDEmptyStateProps {
  /** Заголовок. Строка рисуется типографикой набора, узел — как есть. */
  title?: React.ReactNode;
  /** Пояснение под заголовком. Правило то же, что и для заголовка. */
  subtitle?: React.ReactNode;
  /** Действие: кнопка или несколько. */
  action?: React.ReactNode;
  className?: string;
}

const renderText = (value: React.ReactNode, node: React.ReactElement) => {
  if (value === undefined || value === null || value === false) {
    return null;
  }

  return typeof value === 'string' || typeof value === 'number' ? node : value;
};

/**
 * Пустое состояние: колонка по центру из заголовка, пояснения и действия.
 *
 * Один компонент на все экраны «здесь пока ничего нет». Экран может передать
 * готовые узлы вместо строк, если ему нужна своя типографика — тогда общей
 * остаётся только раскладка.
 */
const UDEmptyState = ({ title, subtitle, action, className }: UDEmptyStateProps) => {
  return (
    <div className={classNames('flex flex-col items-center', className)}>
      {renderText(
        title,
        <UDText as="h2" variant="body-1" className="mb-2">
          {title}
        </UDText>,
      )}

      {renderText(
        subtitle,
        <UDText variant="title-4" className="mb-6">
          {subtitle}
        </UDText>,
      )}

      {action}
    </div>
  );
};

export default UDEmptyState;
